<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'LaporanKeuangan',

    metaInfo: { title: 'Laporan Keuangan' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'financial-report',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'financialreport',
      },
    },
  }
</script>
